import { IGcpAppDispatch, IExtraArgument } from "../../store";
import { IStoreState } from "../../rootReducer";
import {
  putGeolocationCoordinatesReceived,
  putSwitchGeolocationToInactiveState,
  putSwitchGeolocationToErrorState,
  putSwitchGeolocationToWatchingState,
  putSwitchGeolocationToPendingState,
  putSwitchGeolocationToChasingState,
} from "./reducer";

let clearWatch: () => void = null;
const ensureReceivingGeolocationEvents =
  (handlePositionError: (error: GeolocationPositionError) => void) =>
  (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { watchGeolocation }: IExtraArgument,
  ) =>
    new Promise<void>((resolve, reject) => {
      // ignore if we are already subscribed
      if (clearWatch) {
        return resolve();
      }

      clearWatch = watchGeolocation(
        ({ coords }: GeolocationPosition) => {
          dispatch(
            putGeolocationCoordinatesReceived({
              lat: coords.latitude,
              lng: coords.longitude,
            }),
          );
          resolve();
        },
        (positionError: GeolocationPositionError) => {
          const { code, message } = positionError;
          dispatch(
            putSwitchGeolocationToErrorState({ code: `${code}`, message }),
          );
          handlePositionError(positionError);
          clearWatch();
          clearWatch = null;
          reject();
        },
        {
          enableHighAccuracy: true,
        },
      );
    });

export const startGeolocationWatching =
  (handlePositionError: (error: GeolocationPositionError) => void) =>
  (dispatch: IGcpAppDispatch, getState: () => IStoreState) => {
    dispatch(putSwitchGeolocationToPendingState());
    return dispatch(ensureReceivingGeolocationEvents(handlePositionError)).then(
      () => {
        dispatch(putSwitchGeolocationToWatchingState());
      },
      () => {
        // Error is handled in handlePositionError
      },
    );
  };

export const startGeolocationChasing =
  (handlePositionError: (error: GeolocationPositionError) => void) =>
  (dispatch: IGcpAppDispatch, getState: () => IStoreState) => {
    dispatch(putSwitchGeolocationToPendingState());
    return dispatch(ensureReceivingGeolocationEvents(handlePositionError)).then(
      () => {
        dispatch(putSwitchGeolocationToChasingState());
      },
      () => {
        // Error is handled in handlePositionError
      },
    );
  };

// stop watching or chasing, anything
export const stopGeolocation = () => (dispatch: IGcpAppDispatch) => {
  if (clearWatch) {
    clearWatch();
    clearWatch = null;
  }

  dispatch(putSwitchGeolocationToInactiveState());
};
